import ModalViewModel from 'infra/ModalViewModel'
import { action, observable, makeObservable } from 'mobx'
import DocumentType from 'documents/DocumentType'
import { DocumentCreationItemViewModel } from './DocumentCreationItem/DocumentCreationItemViewModel'
import Job from 'jobs/Job'
import UploadBarViewModel from '../DocumentRoot/UploadBar/UploadBarViewModel'
import { FileUpload } from 'documents/dtos/document'
import { Id } from 'types/definitions'

export class DocumentCreationModalViewModel extends ModalViewModel {
  @observable documentCreationItemVMs: DocumentCreationItemViewModel[] = []
  @observable dragging = false
  @observable typesSelected: number = 0

  readonly uploadBarVM: UploadBarViewModel
  readonly job: Job
  readonly documentTypes: DocumentType[]

  constructor(
    files: File[],
    documentTypes: DocumentType[],
    job: Job,
    uploadBarVM: UploadBarViewModel
  ) {
    super()
    makeObservable(this)
    for (const file of files) {
      this.documentCreationItemVMs.push(
        new DocumentCreationItemViewModel(
          file,
          documentTypes,
          this.incrementTypesSelected
        )
      )
    }
    this.documentTypes = documentTypes
    this.uploadBarVM = uploadBarVM
    this.job = job
  }

  @action.bound
  setDragging() {
    this.dragging = true
  }

  @action.bound
  stopDragging() {
    this.dragging = false
  }

  @action.bound
  removeFile(index: number) {
    if (this.documentCreationItemVMs[index].typeName !== 'Select type') {
      this.typesSelected--
    }
    this.documentCreationItemVMs.splice(index, 1)
  }

  @action.bound
  addFiles(files: FileList) {
    Array.from(files).forEach((file) =>
      this.documentCreationItemVMs.push(
        new DocumentCreationItemViewModel(
          file,
          this.documentTypes,
          this.incrementTypesSelected
        )
      )
    )
  }

  @action.bound
  incrementTypesSelected() {
    this.typesSelected++
  }

  async uploadFiles() {
    const files: FileUpload[] = this.documentCreationItemVMs.map((vm) => ({
      file: vm.file,
      options: {
        access: {
          type: 'Job',
          job_id: Id.assert(this.job.id),
        },
        document_type_id: vm.selectedType
          ? Id.assert(vm.selectedType.id)
          : undefined,
        workspace_id: Id.assert(this.job.workspace.id),
      },
    }))
    await this.uploadBarVM.uploadFiles(files)
  }

  close() {
    super.close()
  }
}
